"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.languagesAdapt = void 0;
const languagesAdapt = (t, langSources = []) => (langSources.map((langSource) => (Object.assign(Object.assign({}, langSource), { label: t(langSource.label), subLabel: langSource.subLabel ? t(langSource.subLabel) : null }))));
exports.languagesAdapt = languagesAdapt;
//# sourceMappingURL=languages-adapt.js.map